<!-- backend/src/components/Cards/CardGostergelerTable.svelte -->
<script>
  import { userGostergeList, gostergeList, userList, userGostergeDell } from '../../Api.svelte';
  import { onMount } from 'svelte';
  import { userGosStore, selectedUserGostPer, isPerEditing } from "../../stores/stores";

  export let color = "light";

  let gostergeler = [];
  let userGostergeler = [];
  let users = [];

  onMount(async () => {
    gostergeler = await gostergeList();
    users = await userList();
    userGostergeler = await userGostergeList();
    userGosStore.set(userGostergeler);
  });

  userGosStore.subscribe(sgosterge => {
    userGostergeler = sgosterge;
  });

  async function deleteUserGosterge(id) {
    const confirmed = confirm("Bu göstergeyi silmek istediğinizden emin misiniz? Bu Formülü Sildiğinizde Formüle ait degerler silinecek tir.");
    if (confirmed) {
      await userGostergeDell(id);
      userGostergeler = userGostergeler.filter(sgosterge => sgosterge._id !== id);
      userGosStore.set(userGostergeler);
    }
  }

  function editUserGosterge(sgosterge) {
    selectedUserGostPer.set(sgosterge);
    isPerEditing.set(true);
  }
</script>

<!-- Tablo ve diğer kodlar buraya gelir -->




<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded {color === 'light' ? 'bg-white' : 'bg-red-800 text-white'}">
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-lg {color === 'light' ? 'text-blueGray-700' : 'text-white'}">
          Kullanıcı Gösterge Yetkileri
        </h3>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto">
    <table class="items-center w-full bg-transparent border-collapse">
      <thead>
        <tr>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            No
          </th>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Kullanıcı Adı
          </th>
          <th class="px-6 align-middle lg:w-1/12 border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Gösterge Yetkileri
          </th>

          <th>İşlemler</th>
        </tr>
      </thead>
      <tbody>
        {#each userGostergeler as sgosterge, i}
        <tr class="odd:bg-white odd:dark:bg-gray-200 even:bg-gray-100 even:dark:bg-gray-800">
          <td class="border-t-0 px-6 align-middle border-b text-xs whitespace-nowrap p-4 ">
            {i+1}
          </td>
          <td class="border-t-0 px-6 align-middle border-b text-xs  p-4 ">
            <!-- {getBoyutName(gosterge.boyut_id, boyutlar)} -->
             {users.find(({ _id }) => _id === sgosterge.user_id)?.uname }
          </td>
          <td class="border-t-0 px-6 align-middle border-b text-xs whitespace-nowrap p-4 ">
            {#each sgosterge.gosterge_id as gs_id}
            <!-- {sgosterge.gosterge_id} -->
            <button type="button"  title="{gostergeler.find(({ _id }) => _id === gs_id)?.name}" class="w-32 h-10 truncate  border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-white text-blueGray-600" on:click="{() => toggleGostergeSelection(gosterge._id)}">
                  {gostergeler.find(({ _id }) => _id === gs_id)?.name }
                  <!-- {gostergeler.find(({ _id }) => _id === gs_id)?._id } -->
            </button>
             {/each}
          </td> 
          <td class="px-6 py-4 min-w-48 text-center whitespace-nowrap text-sm font-medium border-b">
            <button class="text-indigo-600 hover:text-indigo-900" on:click="{() => editUserGosterge(sgosterge)}">Düzenle</button>
            <button class="ml-2 text-red-600 hover:text-red-900" on:click="{() => deleteUserGosterge(sgosterge._id)}">Sil</button>
          </td>
        </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>
